module.exports = __webpack_public_path__ + "static/media/coderscave.efb273a4.png";